import axios from 'axios';

export default axios.create({
    baseURL: `${process.env.VUE_APP_SMC_API_URL}`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});
